<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">Situation</p>
		</div>

		<el-title :index="1">
			Localisation
		</el-title>

		<div class="section">
			<div class="part">
				<div class="tle-row">
					<div class="tle-col four-fifth mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 10001 : 0}">
						<map-component height="225" :allow_programs="false" allow_annotations :linkedToView="false"/>
					</div>
					<div class="tle-col one-fifth">
						<div class="part part-images">
							<div class="q-mb-sm">
								<el-image
									:parent_data="active_study.etudeData.scpi.situation.localisation.images[0]"
									property="src"
									:editable="true"
									max_height="99px"
									edition_position="right"
								/>
								<el-textarea
									:parent_data="active_study.etudeData.scpi.situation.localisation.images[0]"
									property="description"
									:editable="true"
									class="text-center text-italic image-description"
								/>
							</div>
							<div>
								<el-image
									:parent_data="active_study.etudeData.scpi.situation.localisation.images[1]"
									property="src"
									:editable="true"
									max_height="99px"
									edition_position="right"
								/>
								<el-textarea
									:parent_data="active_study.etudeData.scpi.situation.localisation.images[1]"
									property="description"
									:editable="true"
									class="text-center text-italic image-description"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-title :index="2">
			Éléments sociodémographiques
		</el-title>

		<el-table :table="table_dynamique" condensed />

		<el-title :index="3">
			Analyse
		</el-title>

		<div class="tle-row">
            <div class="tle-col one-third">
                <div>
                    <p class="label-small">Commercialité</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.scpi.situation.analyse"
                        property="commerciabilite"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Accès transport</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.scpi.situation.analyse"
                        property="accesTransport"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Dynamisme économique</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.scpi.situation.analyse"
                        property="dynamismeEconomique"
                        :max="10"
                        :editable="true"
                    />
                </div>
                <div>
                    <p class="label-small">Notoriété / Image</p>
                    <el-progress-slider
                        :parent_data="active_study.etudeData.scpi.situation.analyse"
                        property="notoriete"
                        :max="10"
                        :editable="true"
                    />
                </div>
            </div>
            <div class="tle-col two-third">
                <div class="comment">
                    <el-textarea
                        class="detail-site"
                        :parent_data="active_study.etudeData.scpi.situation.analyse"
                        property="commentaire"
                        :editable="true"
                        placeholder="Commentaire"
                        :height="'232px'"
                        overflow_edit='hidden scroll'
						text_align="justify"
                    />
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "@/components/study/editor/elements/MapComponent";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	name: "page-kyaneos-2",
	mixins: [ PageMixin ],
	props: [ "index" ],
	components: {
		MapComponent,
		KyaneosHeader
	},
	computed: {
		...mapGetters([ "active_study", "editor" ]),
		table_dynamique: function () {
			const table = { head: [], body: [], config: {
				cols_width: []
			} };
			try{
				const component = this.active_study.qlikData.component.find((component) => {
					return component.id == "1" || component.name == "sociodemographie";
				});

				table.title = component.title[0];

				//todelete : switch mode error/nominal (false => error case)
				//component.valid = true;
				//throw "il y a une erreur"

				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// table.error_message="[BACK] : "+component.errorMessage;
					table.error_message = "Donnée non disponible";

					table.error = true;
				}
               
				const header = component.content.commune.header_list.reduce((accu, curr) => {
					accu.push(curr.value);
					return accu;
				}, []);

				table.head.push(header);

				table.body = component.content.commune.data_list.map(row => {
					const rowArray = [];

					rowArray.push(row.label);

					row.values.forEach((cell, index) => {
						rowArray.push({
							prefix: isNaN(cell.value) || ![1,2,4,5].includes(index) ? "" : cell.value > 0 ? "+" : "-",
							value: isNaN(cell.value) ? cell.value : Math.abs(cell.value),
							suffix: ([2,5].includes(index) || ["Part de CSP+", "Part de chômeurs", "dont part de loc libre", "dont part de loc social"].includes(row.label)) && !isNaN(cell.value) ? " %" : ["Revenu médian"].includes(row.label) && !isNaN(cell.value) ? " €" : cell.suffix,
							format: "number"
						});
					});

					return rowArray;
				});
			}
			// if an error occured in front => //display empty table with error message
			catch(error){
				console.error(error);
				table.error = true;
				table.error_message = "Donnée non disponible";

			}
			return table;
		},
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'
</style>